module.exports = __webpack_public_path__ + "static/media/brand-identity.d1472659.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/design/BrandMaterial/brand-identity.png
// module id = 225
// module chunks = 0